import createImmutableSelector from 'lib/immutable/selector'
import { IPostular } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getPostular = (state: any): IPostular => state.get('postularReducer')

export const postularSelector = createImmutableSelector(getPostular, (postular) => postular)
